module.exports = require("addons-scanner-utils/io");